export class RescheduleFee {
    id?: string;
    href?: string;
    type: string;
    description?: string;
    amount: number;
    currency?: string;
}


export class PaymentFeeDetail {
    id?: string;
    href?: string;
    type: string;
    description?: string;
    amount: number;
    currency?: string;
}